<template>
    <div>
        <van-nav-bar :title="title" left-arrow @click-left="onClickLeft" />
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="draw_area">
                <img class="draw_bg" src="../../assets/roll/bg.jpg" alt="">
                <roulette roulette v-if="type == 'roulette'" :title="title" :explain="explain" :list="list"
                    :juheAppId="juheAppId" :juheAppName="juheAppName" :score="score" :endTime="endTime"
                    :startTime="startTime" :freetime="freetime" :rollNum="roll_num" @changeFreeTime="changeFreeTime"
                    :lotteryType="lotteryType"></roulette>
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
    import roulette from "./children/Roulette";
    import api from '../Api'
    export default {
        mixins: [api],
        components: {
            roulette: roulette
        },
        computed: {
            type() {
                if (this.$route.params.type == "roulette") {
                    return "roulette";
                }
            },
            lotteryId() {
                return this.$route.query.lottery_id;
            },
        },
        data() {
            return {
                lotteryType: '',
                //活动标题
                title: "",
                //活动规则
                explain: "",
                //奖品列表
                list: [],
                juheAppId: '',
                juheAppName: '',
                //活动所需积分
                score: '',
                endTime: '',
                startTime: '',
                freetime: 0,
                roll_num: 0
            }
        },
        mounted() {
            this.getlotterydetail()
        },
        methods: {
            changeFreeTime(val) {
                this.freetime = val
            },
            //获取活动轮盘内容
            getlotterydetail() {
                //ajax
                this.$Ajax('shop/activity-lottery-detail', {
                    lotteryId: this.lotteryId
                }).then(rs => {
                    if (rs.code == 200) {
                        this.lotteryType = rs.data.type
                        this.free_time = rs.data.free_time
                        this.endTime = rs.data.end_time.replace(/-/g, "/")
                        this.startTime = rs.data.start_time.replace(/-/g, "/")
                        this.title = rs.data.title;
                        this.explain = rs.data.explain;
                        this.juheAppId = rs.data.juhe_app_id
                        this.juheAppName = rs.data.game_name
                        this.score = rs.data.point
                        this.list = rs.data.detail
                        this.roll_num = rs.data.roll_num || 0
                        if (this.type == 'roulette') {
                            var thanks = {
                                id: 0,
                                title: '谢谢惠顾',
                                icon: require('../../assets/roll/j1.png')
                            }
                            if (rs.data.detail.length == 1) {
                                this.list.splice(1, 0, thanks);
                                this.list.splice(2, 0, thanks);
                                this.list.splice(3, 0, thanks);
                                this.list.splice(4, 0, thanks);
                                this.list.splice(5, 0, thanks);
                                this.list.splice(6, 0, thanks);
                                this.list.splice(7, 0, thanks);
                            } else if (rs.data.detail.length == 2) {
                                this.list.splice(0, 0, thanks);
                                this.list.splice(1, 0, thanks);
                                this.list.splice(2, 0, thanks);
                                this.list.splice(4, 0, thanks);
                                this.list.splice(5, 0, thanks);
                                this.list.splice(6, 0, thanks);
                            } else if (rs.data.detail.length == 3) {
                                this.list.splice(1, 0, thanks);
                                this.list.splice(2, 0, thanks);
                                this.list.splice(3, 0, thanks);
                                this.list.splice(5, 0, thanks);
                                this.list.splice(7, 0, thanks);
                            } else if (rs.data.detail.length == 4) {
                                this.list.splice(1, 0, thanks);
                                this.list.splice(3, 0, thanks);
                                this.list.splice(5, 0, thanks);
                                this.list.splice(7, 0, thanks);
                            } else if (rs.data.detail.length == 5) {
                                this.list.splice(2, 0, thanks);
                                this.list.splice(4, 0, thanks);
                                this.list.splice(6, 0, thanks);
                            } else if (rs.data.detail.length == 6) {
                                this.list.splice(3, 0, thanks);
                                this.list.splice(7, 0, thanks);
                            } else if (rs.data.detail.length == 7) {
                                this.list.splice(2, 0, thanks);
                            } else if (rs.data.detail.length > 8) {
                                this.list.slice(0, 9);
                            }
                        }
                    }
                })
            }
        },
    }
</script>

<style lang="less" scoped>
    .draw_area {
        background-color: #670000;
        min-height: calc(var(--vh, 1vh)*100 - 2.5rem);
        margin-top: 2.5rem;
        overflow: hidden;
        position: relative;

        .draw_bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: auto;
            z-index: 1;
        }
    }
</style>